import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../modules/footer/Footer";
import Navbar from "../modules/navbar/Navbar";

function Body() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

export default Body;
